import { create_private_room } from './chat_utils';

export default class ChatAddRoom {
  constructor(opts) {
    this.user = opts.user;
    this.user_email = opts.user_email;
    this.users_list = []; // emails for both MultiSelectPills and Link field
    this.setup();
    this.load_users();
  }

  async load_users() {
    try {
      const response = await frappe.call({
        method: 'chat.api.user.get_users_emails',
      });
      const data = response.message || {};
      const emails = data.emails || [];
      
      // Use emails for both fields
      this.users_list = [...emails, 'Administrator'];
      this.users_list = this.users_list.filter((user) => {
        return user != this.user_email;
      });
      
      // Update the users field (MultiSelectPills)
      this.update_users_field();
      
      // Update the user field (Link field) - ensure it's ready
      this.update_user_field();
      
      console.log(this.users_list);
    } catch (error) {
      console.error('Error loading users:', error);
      // Fallback to empty list or handle error
      this.users_list = ['Administrator'];
      this.update_users_field();
    }
  }

  update_users_field() {
    if (this.add_room_dialog && this.add_room_dialog.fields_dict.users) {
      // Update the options property
      this.add_room_dialog.set_df_property('users', 'options', this.users_list);
      
      // Convert to format expected by MultiSelectPills
      // Format: array of objects with value and label, or array of strings
      const users_data = this.users_list.map(email => {
        // If it's already an object, return as is, otherwise create object
        if (typeof email === 'object') {
          return email;
        }
        return {
          value: email,
          label: email
        };
      });
      
      const users_field = this.add_room_dialog.fields_dict.users;
      if (users_field && users_field.set_data) {
        users_field.set_data(users_data);
      }
      
      // Refresh the field to apply changes
      if (users_field && users_field.refresh) {
        users_field.refresh();
      }
    }
  }

  update_user_field() {
    if (this.add_room_dialog && this.add_room_dialog.fields_dict.user) {
      const user_field = this.add_room_dialog.fields_dict.user;

      const users_data = this.users_list.map((email) => ({
        value: email,
        label: email,
      }));

      if (user_field?.set_data) {
        user_field.set_data(users_data);
      } else if (user_field?.df) {
        user_field.df.options = users_data;
      }

      user_field?.refresh?.();
    }
  }

  async setup() {
    this.add_room_dialog = new frappe.ui.Dialog({
      title: __('New Chat Room'),
      fields: [
        {
          label: __('Room Type'),
          fieldname: 'type',
          fieldtype: 'Select',
          options: ['Group', 'Direct'],
          default: 'Group',
          onchange: () => {
            const type = this.add_room_dialog.get_value('type');
            const is_group = type === 'Group';
            this.add_room_dialog.set_df_property('room_name', 'reqd', is_group);
            this.add_room_dialog.set_df_property('users', 'reqd', is_group);
            this.add_room_dialog.set_df_property('user', 'reqd', !is_group);
            
            // When switching to Direct, ensure user field is refreshed
            if (!is_group && this.add_room_dialog.fields_dict.user) {
              this.update_user_field();
            }
          },
          reqd: true,
        },
        {
          label: __('Room Name'),
          fieldname: 'room_name',
          fieldtype: 'Data',
          depends_on: "eval:doc.type == 'Group'",
          reqd: true,
        },
        {
          label: __('Users'),
          fieldname: 'users',
          fieldtype: 'MultiSelectPills',
          options: this.users_list,
          depends_on: "eval:doc.type == 'Group'",
          reqd: true,
        },
        {
          label: __('User'),
          fieldname: 'user',
          fieldtype: 'Autocomplete',
          depends_on: "eval:doc.type == 'Direct'",
        },
      ],
      action: {
        primary: {
          label: __('Create'),
          onsubmit: (values) => {
            let users = this.add_room_dialog.fields_dict.users.get_values();
            let room_name = values.room_name;
            if (values.type === 'Direct') {
              users = [values.user];
              room_name = 'Direct Room';
            }
            this.handle_room_creation(room_name, users, values.type);
            this.add_room_dialog.hide();
          },
        },
      },
    });

    if (this.add_room_dialog?.fields_dict?.user) {
      this.add_room_dialog.fields_dict.user.df.ignore_user_permissions = 1;
    }
  }

  show() {
    console.log('show called');
    console.log(this.users_list);
    console.log(this.add_room_dialog);
    console.log(this.user);
    console.log(this.user_email);
    
    // Ensure fields are updated before showing
    if (this.users_list.length > 0) {
      this.update_users_field();
      this.update_user_field();
    }
    
    this.add_room_dialog.show();
  }

  async handle_room_creation(room_name, users, type) {
    try {
      await create_private_room(room_name, users, type);
      this.add_room_dialog.clear();
    } catch (error) {
      //pass
    }
  }
}
